module.exports = __webpack_public_path__ + "media/images/flags/ba-45c5842b34d4196c48048c0ce600266b.svg";